import { gsap } from 'gsap';
import Section from 'scripts/core/section';
import { inFrames } from 'scripts/utils/inFrames';
import { ContactPageSections } from 'common/views/sectionTypes';
import { PRELOADER_ACTIVE_CLASS } from 'scripts/utils/constants';
import { Easings } from 'scripts/utils/tweenHelpers';
import { ScrollSmoother } from 'scripts/lib/gsap/scrollSmoother';
import { scrollToTop } from 'scripts/utils/scrollToTop';
import { setupSection } from 'scripts/utils/setupComponents';

export default class ContactSection extends Section {
    private get _smoother() { return ScrollSmoother.get(); }

    private get _textWrapper() { return this.element.querySelector('.animated-text-block'); }
    private get _formWarp() { return this.element.querySelector('.contact-form-wrap'); }

    async setupSection() {
        this.changeColorFooter();
        this._setupAnimation();
    }

    public start() {
        return this.startInViewAnimation();
    }

    private changeColorFooter() {
        const footer = document.querySelector('.footer');
        footer.classList.add('color-violet-white');
    }


    private _setupAnimation() {
        gsap.set([this._formWarp], { autoAlpha: 0 });
    }


    private enableScroll = () => {
        document.body.classList.remove(PRELOADER_ACTIVE_CLASS);
        this._smoother?.normalizer?.enable();
    };

    private disableScroll = () => {
        document.body.classList.add(PRELOADER_ACTIVE_CLASS);
        this._smoother?.normalizer?.disable();

        scrollToTop();
    };

    public startInViewAnimation = async () => {
        this.disableScroll();

        const timelineInit = gsap.timeline();

        await timelineInit
            .to(this._textWrapper, { y: 0, duration: inFrames(70), ease: Easings.customEaseInOut }, 0)
            .fromTo(this._formWarp, { y: 100 }, { y: 0, autoAlpha: 1, duration: inFrames(30), ease: Easings.customEase }, inFrames(30));

        this.enableScroll();
    };

}

setupSection(ContactSection, { id: ContactPageSections.Hero, start: setupSection.StartType.PageReady });
